import Tile from "../Tile/Tile"
import TileRecordView from "../Tile/TileRecordView"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileMilestoneSettingsModal } from "./TileMilestoneSettingsModal"

export default function MilestonesTile({
  canEdit = true,
  isTemplate,
  overview,
  tileFetchParams,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileMilestoneSettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const hasFields = tile.fields && tile.fields.length > 0

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
      title={tile.name}
      canEdit={canEdit}
      breakoutLink={!isTemplate && tile.breakout_link}
    >
      {hasFields ? (
        <TileRecordView
          data={tile.data || { values: {} }}
          fields={tile.fields}
          isDoubleColumn={false}
          displayEmptyValues={tile.show_empty_values}
        />
      ) : (
        <div
          className={
            "flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7"
          }
        >
          {tile.empty_state_message}
        </div>
      )}
    </Tile>
  )
}
